"use client";

import { c as _c } from "react/compiler-runtime";
import { isAbstractWalletAccount } from "../lib/wagmi/helpers";
import { useConnectorId } from "../polychain/hooks/useConnectorId";

/**
 * Hook to determine if the current wallet is an abstract wallet account
 * @returns boolean indicating if the current connector is an abstract wallet
 */
export function useIsAbstractWalletAccount() {
  const $ = _c(2);
  const connectorId = useConnectorId();
  let t0;
  if ($[0] !== connectorId) {
    t0 = connectorId ? isAbstractWalletAccount(connectorId) : false;
    $[0] = connectorId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}